import React, { memo, useRef } from "react"

import type { CardProps } from "components/FollowedBrandsPage/Card"
import useFollowingBrands from "hooks/useFollowingBrands"

interface UndoButtonProps {
  id: CardProps[`id`]
}

const getCurrentPageNumber = () => {
  if (window.location.pathname.includes(`/my-account/followed-brands/`)) {
    const searchParams = window.location.search

    if (!searchParams || searchParams === ``) return 1
    const pageNumber = new URLSearchParams(searchParams).get(`p`)

    return pageNumber ? parseInt(pageNumber, 10) : 1
  } else {
    return undefined
  }
}

const UndoButton = memo(({ id }: UndoButtonProps) => {
  const pageNumber = useRef(getCurrentPageNumber())
  const { follow } = useFollowingBrands({ id, brandPage: pageNumber.current })

  return (
    <button className="font-medium underline" onClick={follow} type="button">
      Undo
    </button>
  )
})

export default UndoButton
